import {FormControlLabel, TextField, Checkbox, Grid} from '@mui/material';
import React, { Fragment } from 'react';
import {useTranslation} from "react-i18next";
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_TIME} from './SearchCommon.js';

export const TL_NO_LIMIT			= 0;
export const TL_TODAY				= 1;
export const TL_TODAY_AND_YESTERDAY		= 2;
export const TL_RANGE				= 3;
export const TL_TODAY_AND_TWO_PREVIOUS_DATES	= 4;

function FilterTime(props) {
	const {t} = useTranslation('obs');
	const gStorage = useGlobalStorage();

	if (gStorage.main.filter.tab !== TAB_TIME)
		return null;

	return(
		<Fragment>
			<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={t('filter.no_time_limit')}
					labelPlacement="start"
					checked={props.filter.time.t_type === TL_NO_LIMIT}
					onChange={props.nolimitCheck}
					control={<Checkbox color="primary" />}
					style={{margin: 0}}
				/>
			</Grid>
			<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={t('filter.today')}
					labelPlacement="start"
					checked={props.filter.time.t_type === TL_TODAY}
					onChange={props.todayCheck}
					control={<Checkbox color="primary" />}
					style={{margin: 0}}
				/>
			</Grid>
			<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={t('filter.today_and_yesterday')}
					labelPlacement="start"
					checked={props.filter.time.t_type === TL_TODAY_AND_YESTERDAY}
					onChange={props.todayAndYesterdayCheck}
					control={<Checkbox color="primary" />}
					style={{margin: 0}}
				/>
			</Grid>
			<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={t('filter.today_and_two_previous_dates')}
					labelPlacement="start"
					checked={props.filter.time.t_type === TL_TODAY_AND_TWO_PREVIOUS_DATES}
					onChange={props.todayAndTwoPreviousCheck}
					control={<Checkbox color="primary" />}
					style={{margin: 0}}
				/>
			</Grid>
			<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={t('filter.range')}
					labelPlacement="start"
					checked={props.filter.time.t_type === TL_RANGE}
					onChange={props.rangeCheck}
					control={<Checkbox color="primary" />}
					style={{margin: 0}}
				/>
			</Grid>
			<Grid size={{xs: 12}} align={'center'}>
				<TextField 
					label={t('add.start_date')}
					value={props.startDate}
					onChange={props.startDChange}
					style={{width: 143, margin: 4}} 
					variant="outlined" 
					error={!props.startDateValid}
					disabled={props.filter.time.t_type !== TL_RANGE}
					size="small" />
				<TextField 
					label={t('add.end_date')}
					value={props.endDate}
					onChange={props.endDChange}
					style={{width: 143, margin: 4}} 
					variant="outlined" 
					error={!props.endDateValid}
					disabled={props.filter.time.t_type !== TL_RANGE}
					size="small" />
			</Grid>
		</Fragment>
	);
};

export default FilterTime;
